// Goods Product.js

import React, {Component} from 'react';
import {Button, Form, Container, Row, Col, ButtonToolbar, Overlay, Popover} from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import styles from './Table.css';
import {JsonToExcel} from 'react-json-excel';

const ProductLocals = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];

const className = 'class-name-for-style',
    filename = 'GoodsProductDownList_Excel-file',
    fields = {
        "ID": "ID",
        "PCODE": "PCODE",
        "QRCODE": "QRCODE",
        "SERIAL": "SERIAL",
        "USEDATE": "USEDATE",
        "DOWNDATE": "DOWNDATE",
        "REGDATE": "REGDATE",
        "MEMO": "MEMO",
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "37.64px"
    }

class Content extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            qrlistvisible: false,
            item: this.props.item,
            enable: false,
            images: [],
        };
        this.locals = ProductLocals;
        this.S3timer = null;
    }

    componentWillReceiveProps(nextProps) {
        console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({item: nextProps.item, enable: nextProps.enable});
    }

    handleReset(event) {
        var result = confirm("리셋 하시겠습니까?");
        if (result) {
            Config.fetchData('resetGoodsDown', {
                MEMO: this.state.item.MEMO,
                PCODE: this.state.item.PCODE,
                SERIAL: this.state.item.SERIAL
            }, (result, count) => {
                console.log('resetGoodsDown=', count);
                this.setState({sendcount: count});
                if (count == 1) {
                    this.setState({
                        item: {
                            PCODE: this.state.item.PCODE, QRCODE: this.state.item.QRCODE, SERIAL: this.state.item.SERIAL, USEDATE: '', DOWNDATE: '', MEMO: this.state.item.MEMO
                        }
                        , enable: true
                    });
                }
            }, true);
        }
        event.preventDefault();
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({item: item});
    }


    handleChangeMEMO(event) {
        var item = this.state.item;
        item.MEMO = event.target.value;
        this.setState({item: item});
    }



    handleSubmit(event) {
        var result = confirm("저장 하시겠습니까?");
        if (result) {
            Config.fetchData('updateGoodsDown', {
                MEMO: this.state.item.MEMO,
                PCODE: this.state.item.PCODE,
                SERIAL: this.state.item.SERIAL
            }, (result, count) => {
                console.log('updateGoodsDown=', count);
                this.setState({sendcount: count})
            }, true);
        }
        event.preventDefault();
    }

    render() {
        return (
            <div className="box" >
                <div className="row" style={{margin: 20}}>
                    <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                    <Button variant="primary" onClick={this.handleReset.bind(this)}>재사용</Button>
                </div>
                <div className="row" >
                    <Form>
                        {this.state.enable && <div style={{margin: 20}}>
                            <div className="col-md-6">
                                <Form.Row>
                                    <Form.Group as={Col} controlId="exampleForm.ControlInput1">
                                        <Form.Label>상품코드</Form.Label>
                                        <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE} />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>QR CODE</Form.Label>
                                    <Form.Control type="title" placeholder="내용이 없습니다." value={this.state.item.QRCODE} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>시리얼 번호</Form.Label>
                                    <Form.Control type="title" placeholder="내용이 없습니다." value={this.state.item.SERIAL} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>사용일자</Form.Label>
                                    <Form.Control type="title" placeholder="내용이 없습니다." value={this.state.item.USEDATE} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>다운로드 일자</Form.Label>
                                    <Form.Control type="title" placeholder="내용이 없습니다." value={this.state.item.DOWNDATE} />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>CS 내용</Form.Label>
                                    <Form.Control as="textarea" rows={5} type="textarea" placeholder="내용을 입력하세요." value={this.state.item.MEMO} onChange={this.handleChangeMEMO.bind(this)} />
                                </Form.Group>
                            </div>
                        </div>
                        }
                    </Form>
                </div>
            </div>
        );
    }
};

export default class GoodsDownload extends Component {
    static defaultProps = {
        onreset: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            rowlist: [],
            productvisible: false,
            item: {
                PCODE: '0000', QRCODE: '', SERIAL: '', USEDATE: '', DOWNDATE: '', REGDATE: '', MEMO: ''
            }
        };
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        var edititem = {...item};
        this.setState({item: edititem});
        this.setState({productvisible: true});

        event.preventDefault();
    }

    componentDidMount() {
        Config.fetchData('getGoodsDownloadList', {
        }, (result, count) => {
            console.log('count=', count);
            result.forEach(element => {
                element.USEDATE = element.USEDATE == null ? '' : element.USEDATE;
                element.DOWNDATE = element.DOWNDATE == null ? '' : element.DOWNDATE;
                element.MEMO = element.MEMO == null ? '' : element.MEMO;
            });
            this.setState({rowlist: result})  
        }, true);
    }

    handleReset(event) {
        this.setState({
            item: {
                PCODE: '0000', QRCODE: '', SERIAL: '', USEDATE: '', DOWNDATE: '', REGDATE: '', MEMO: ''
            }
        })
    }

    handleNew() {
        this.handleReset(null);
        this.setState({productvisible: true});
    }

    handleClose = () => {
        console.log('handleClose');
        this.componentDidMount();
        this.setState({productvisible: false});
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const {rowCount} = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({scrollToIndex});
    }

    _rowClassName({index}) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    render() {
        let scrollbarStyles = {borderRadius: 5};
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">Goods 다운로드내역</h3>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                {this.state.rowlist.length > 0 ?
                                                    <JsonToExcel
                                                        data={this.state.rowlist}
                                                        className={className}
                                                        filename={filename}
                                                        fields={fields}
                                                        style={style}
                                                    />
                                                    :
                                                    null
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{margin: 20}}>
                                    <div className="row" >
                                        <AutoSizer disableHeight>
                                            {({width}) => (
                                                <Table
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({index}) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={80}
                                                        disableSort
                                                        label="#"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={70}
                                                        disableSort
                                                        label="코드"
                                                        dataKey="PCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        style={{minWidth: 40}}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="QRCODE"
                                                        dataKey="QRCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="시리얼번호"
                                                        dataKey="SERIAL"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="사용날짜"
                                                        dataKey="USEDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="다운로드날짜"
                                                        dataKey="DOWNDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="등록일"
                                                        dataKey="REGDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="cs내용"
                                                        dataKey="MEMO"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({cellData}) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </Table>
                                            )}
                                        </AutoSizer>
                                    </div>
                                    <div className="row">
                                        <Modal visible={this.state.productvisible} width="80%" effect="fadeInUp" onreset={() => {this.componentDidMount()}} onClickAway={() => this.handleClose()}>
                                            <div style={{margin: 20}}>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <div className="row" style={{margin: 16}}>
                                                                <Button variant="primary" onClick={this.handleClose.bind(this)}>X</Button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h2>재사용 변경</h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <Content item={this.state.item} enable={this.state.productvisible} onreset={() => {this.componentDidMount()}} />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/DigitalGoods/DownloadList.js